export const Prestaciones = Object.freeze({
    PECATA: 1,
    POCATA: 2,
    POECATA: 7,
    PETECATA: 8,
    CAEX2: 10,
    CAOE2: 11,
    CAO2: 12,
    PCAR: 13,
    CATE2: 14,
    CAEX3: 15,
    CAOE3: 16,
    PCAR2: 17,
    CATE3: 18,
    CAEX4: 19,
    CAOE4: 20,
    CATE4: 21,
    PCAR3: 22,
    CAEX5: 24,
    CAOE5: 25,
    CATE5: 26,
    PCAR4: 27,
    CAEX6: 28,
    PDIR: 23
});

export const Build = Object.freeze({
    UIVERSION : '2022-08-31T07:02:47Z'
});